<mat-card>
    <h3 class="col-md-12">Mentions légales et Charte du site</h3>
    <p class="col-md-12">
        Vous êtes actuellement connecté sur un site dont les données sont hébergées sur les serveurs informatiques de
        l’Institut Gustave Roussy
    </p>

    <h5 class="col-md-12">Informations éditeur</h5>
    <p class="col-md-12">
        Ce site est édité par Gustave Roussy.<br /><br />
        <b>Adresse légale</b><br />
        Institut Gustave Roussy<br />
        39 bis, rue Camille Desmoulins<br />
        94805 Villejuif Cedex<br />
        N° SIRET : 775 741 101 00031<br /><br />
        <b>Directeur de la publication</b><br />
        Professeur Jean-Charles Soria<br />
        Directeur général de Gustave Roussy<br /><br />
        <b>Contact technique</b><br />
        support-mon&#64;gustaveroussy.fr<br />
    </p>



    <h5 class="col-md-12">Mission du site</h5>
    <p class="col-md-12">
        Le site <a  href="https://rdv.gustaveroussy.fr" target="_blank">https://rdv.gustaveroussy.fr</a>  
        a pour mission de vous fournir un service de gestion de rendez-vous médical en ligne.<br /><br />
        La navigation sur ce site est soumise à la réglementation en vigueur et aux présentes conditions d'utilisation. <br />
        Ces dernières étant mises à jour régulièrement, vous êtes invité à consulter cette page à l'occasion de chaque
        connexion au site. Il appartient à toute personne navigant sur ce site de s'assurer qu'elle a le droit, aux
        termes
        de sa législation locale, d'accéder à ce site et/ou de l'utiliser, Gustave Roussy ne pouvant en aucun cas être
        tenu
        pour responsable en cas de violation d'une telle réglementation locale.<br /><br />

        Aucune publicité n’est affichée sur le site gustaveroussy.fr. Dans le cadre de sa mission, le site
        gustaveroussy.fr
        est cependant susceptible de promouvoir ou de relayer à titre gracieux des actions dans le domaine de la lutte
        contre le cancer.<br /><br />
        Le site <a  href="https://rdv.gustaveroussy.fr" target="_blank">https://rdv.gustaveroussy.fr</a> est entièrement financé par Gustave Roussy.
    </p>

    <h5 class="col-md-12">Propriété intellectuelle</h5>
    <p class="col-md-12">

        L'ensemble du site, notamment les images, les textes, les représentations iconographiques et photographiques et
        les
        documents téléchargeables du site, relève de la législation française et internationale sur le droit d'auteur et
        la
        propriété intellectuelle. La reproduction ou la représentation de tout ou partie de ce site, sur quel que
        support
        que ce soit, est donc formellement interdite sauf accord préalable écrit du Directeur de la publication.
    </p>

    <h5 class="col-md-12">Liens hypertextes et virus</h5>
    <p class="col-md-12">

        Il est expressément rappelé que Gustave Roussy n'a aucun contrôle ni aucune responsabilité quant à la création
        de
        liens vers des sites extérieurs à Gustave Roussy et quant au contenu des dits sites. Aussi, acceptez-vous que
        votre
        choix d'accéder à un autre site, par l'intermédiaire d'un lien hypertexte, s'effectue à vos risques et périls.
        En
        conséquence, tout préjudice direct ou indirect résultant de votre accès à un autre site relié par un lien
        hypertexte
        ne peut engager la responsabilité de Gustave Roussy. De façon générale, il vous appartient de prendre les
        précautions nécessaires pour vous assurer que le site que vous sélectionnez n'est pas infesté de virus ou de
        tout
        autre parasite de nature destructive. En aucun cas, Gustave Roussy ne pourra être tenu responsable des dommages
        directs ou indirects résultant de l'usage de son site Internet ou d'autres sites qui lui sont liés.
    </p>

    <h5 class="col-md-12">Hébergement du site</h5>
    <p class="col-md-12">
        <b>Gustave Roussy</b><br />
        Institut Gustave Roussy<br />
        39 bis, rue Camille Desmoulins <br />
        94 805 Villejuif Cedex<br />
    </p>

    <h5 class="col-md-12">Conception, réalisation, maintenance</h5>
    <p class="col-md-12">
        <b>Jasparo</b><br />
        34 rue de Picpus<br />
        75012 Paris<br />
        <a  href="https://jasparo.fr" target="_blank">jasparo.fr</a><br />
    </p>
</mat-card>